import countries from 'i18n-iso-countries'
import Cookies from 'js-cookie'
import ky from 'ky'
import type {CountryCode} from 'libphonenumber-js'

import {paramCookiesMap} from '@helios/shared/config/cookies'
import {getDefaultLocale} from '@helios/shared/providers/locale'
import type CompanySize from '@helios/shared/types/company-size'
import type DiscoveredVia from '@helios/shared/types/discovered-via'
import type {HubspotContactProps} from '@helios/shared/types/hubspot-contact-props'
import {isGenericEmail} from '@helios/shared/utils/is-generic-email'

interface StateProps {
    firstName?: string
    lastName?: string
    email: string
    phoneNumber?: string
    phoneCountryCode?: CountryCode
    company?: string
    companySize?: CompanySize | ''
    country?: Lowercase<CountryCode> | typeof OTHER | ''
    discoveredVia?: DiscoveredVia | ''
    hasConsented?: boolean
    marketingEmails?: boolean
}

const OTHER = 'Other' as const

const createHubspotContact = async (
    captchaResponse: string,
    state: StateProps,
    properties?: Partial<HubspotContactProps>
) => {
    const contactData: Partial<HubspotContactProps> = {
        firstname: state.firstName,
        lastname: state.lastName,
        phone: state.phoneNumber,
        email: state.email,
        generic_email: isGenericEmail(state.email) ? 'true' : 'false',
        company: state.company,
        hs_legal_basis: state.marketingEmails ? 'Freely given consent from contact' : '',
        country: getCountryName(state.country),
        numemployees: state.companySize,
        how_did_you_hear_about_us_: state.discoveredVia,
        utm_source: Cookies.get(paramCookiesMap.utmSource) || '',
        utm_medium: Cookies.get(paramCookiesMap.utmMedium) || '',
        utm_campaign: Cookies.get(paramCookiesMap.utmCampaign) || '',
        utm_term: Cookies.get(paramCookiesMap.utmTerm) || '',
        utm_content: Cookies.get(paramCookiesMap.utmContent) || '',
        latest_utm_source: Cookies.get(paramCookiesMap.latestUtmSource) || '',
        latest_utm_medium: Cookies.get(paramCookiesMap.latestUtmMedium) || '',
        latest_utm_campaign: Cookies.get(paramCookiesMap.latestUtmCampaign) || '',
        latest_utm_term: Cookies.get(paramCookiesMap.latestUtmTerm) || '',
        latest_utm_content: Cookies.get(paramCookiesMap.latestUtmContent) || '',
        referral_id: Cookies.get(paramCookiesMap.referralCode) || '',
        ...properties,
    }

    await ky
        .post('/api/hubspot-create-contact', {
            json: {contactData, captchaResponse},
            throwHttpErrors: false,
        })
        .json()
}

const getCountryName = (country: StateProps['country']) => {
    const defaultLocale = getDefaultLocale()

    countries.registerLocale(require(`i18n-iso-countries/langs/${defaultLocale.language}.json`))

    if (!country) {
        return undefined
    }

    if (country === OTHER) {
        return OTHER
    }

    return countries.getName(country, defaultLocale.language) as StateProps['country']
}

export default createHubspotContact
